<template>
  <v-row dense>
    <v-col>
      <v-row dense no-glitter v-if="hasHistoryPresentIllness">
        <v-col class=pb-1>
          <v-card class="fill-height">
            <v-container fluid>
              <v-row dense>
                <v-col>
                  <span class="ps-3 text-h5 gray--text">
                    H.M.A:
                  </span>
                  <span>
                    {{ historyPresentIllness.description }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense no-glitter v-if="hasHistoryPathology">
        <v-col class=pb-1>
          <v-card class="fill-height">
            <v-container fluid >
              <v-row>
                <v-col>
                  <span class="ps-3 text-h5 gray--text">
                    H.P.P:
                  </span>
                  <span>
                    {{ historyPathology.description }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row dense no-glitter>
        <v-col class=pb-1>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-h5 gray--text">A.V Refração</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <DynamicFormCore
                dynamicFormType="summary_avref"
                :answerableId="attendance.id"
                answerableType="Attendance"
                :disabled="true"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row dense no-glitter>
        <v-col class=pb-1>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <span class="text-h5 gray--text">Motilidade</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <DynamicFormCore
                dynamicFormType="summary_prcm"
                :answerableId="attendance.id"
                answerableType="Attendance"
                :disabled="true"
              />
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>

      <!-- <v-row dense no-glitter v-if="hasBio"> -->
      <!--   <v-col class=pb-1> -->
      <!--     <v-card class="fill-height"> -->
      <!--       <v-container fluid > -->
      <!--         <v-row dense> -->
      <!--           <v-col > -->
      <!--             <span class="ps-3 text-h5 gray--text"> -->
      <!--               Biomicroscopia: -->
      <!--             </span> -->
      <!--             <span> -->
      <!--               {{ biomicroscopy.description }} -->
      <!--             </span> -->
      <!--           </v-col> -->
      <!--         </v-row> -->
      <!--       </v-container> -->
      <!--     </v-card> -->
      <!--   </v-col> -->
      <!-- </v-row> -->

      <v-row dense no-glitter v-if="hasBio">
        <v-col dense no-glitter class="pb-0 mb-1">
        <v-expansion-panels class="mt-0 ps-0 mb-0">
          <v-expansion-panel class="mt-0 mb-0 ps-0" >
            <v-expansion-panel-header>
              <span class="text-h5 gray--text space mt-0 pb-0">Biomicroscopia</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ps-0 ms-0">
              <v-row dense no-glitter col="10" class="ps-0 ms-0" >
                  <span>
                    {{ biomicroscopy.description }}
                  </span>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row dense no-glitter v-if="hasFundoscopy">
        <v-col dense no-glitter class="pb-0 mb-1">
        <v-expansion-panels class="mt-0 ps-0 mb-0">
          <v-expansion-panel class="mt-0 mb-0 ps-0" >
            <v-expansion-panel-header>
              <span class="text-h5 gray--text space mt-0 pb-0">Fundoscopia</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ps-0 ms-0">
              <v-row dense no-glitter col="10" class="ps-0 ms-0" >
                  <span>
                    {{ fundoscopy.description }}
                  </span>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row dense no-glitter v-if="hasApplanationTonometries || hasBreathTonometries">
        <v-col dense no-glitter class="pb-0 mb-1">
        <v-expansion-panels class="mt-0 ps-0 mb-0">
          <v-expansion-panel class="mt-0 mb-0 ps-0" >
            <v-expansion-panel-header>
              <span class="text-h5 gray--text space mt-0 pb-0">Tonometria</span>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="ps-0 ms-0">
              <v-row dense no-glitter col="10" class="ps-0 ms-0" >
                  <v-col dense cols="5" class="ps-0 pt-0 mt-0 me-4" >
                   <BreathTonometry :attendance="attendance" readOnly />
                   </v-col>
                  <v-col dense cols="5" class="ps-0 ms-0">
                    <ApplanationTonometry :attendance="attendance" readOnly />
                  </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </v-col>
      </v-row>

      <v-row dense no-glitter>
        <v-col dense no-glitter class="pb-0 mb-1">
          <v-card class="fill-height">
            <v-container fluid v-if="hasConduct">
              <v-row dense>
                <v-col>
                  <span class="ps-3 text-h5 gray--text">
                    Conduta:
                  </span>
                  <span>
                    {{ conduct.observation }}
                  </span>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="activeDiagnosticHypotheses.length > 0" >
        <v-col>
          <h3>CIDs ativas</h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="diagnosticHypothesis in activeDiagnosticHypotheses"
          :key="diagnosticHypothesis.id"
          cols="12"
        >
          <DiagnosticHypothesis
            :attendance="attendance"
            :diagnosticHypothesis="diagnosticHypothesis"
            :disabled="true"
          />
        </v-col>
      </v-row>

      <v-row v-if="inactiveDiagnosticHypotheses.length > 0">
        <v-col>
          <h3>
            CIDs inativas
          </h3>
        </v-col>
      </v-row>

      <v-row>
        <v-col
          v-for="diagnosticHypothesis in inactiveDiagnosticHypotheses"
          :key="diagnosticHypothesis.id"
          cols="12"
        >
          <DiagnosticHypothesis
            :attendance="attendance"
            :diagnosticHypothesis="diagnosticHypothesis"
            :disabled="true"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h3>Receita de óculos</h3>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <GlassPresciptionList
            :attendance="attendance"
            :allowEdit="false"
            :allowDelete="false"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h3>Receituário</h3>
        </v-col>
      </v-row>

      <v-row dense>
        <v-col>
          <PrescriptionList
            :attendance="attendance"
            :allowEdit="false"
            :allowDelete="false"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <h3>Lentes de Contato adaptadas</h3>
        </v-col>
      </v-row>

      <ContactLensTestList
        :attendance="attendance"
        :disabled="true"
        :onlyAdapted="true"
      />

      <Allergy
        :attendance="attendance"
        :showForm="false"
        :allowDelete="false"
      />

      <MedicationHistory
        :attendance="attendance"
        :showForm="false"
        :allowDelete="false"
      />
    </v-col>
  </v-row>
</template>

<script>
import DiagnosticHypothesis from "@/components/medical_record/hd/diagnostic_hypothesis.vue";
import BreathTonometry from "@/components/medical_record/biomicroscopy/breath_tonometry.vue"
import ApplanationTonometry from "@/components/medical_record/biomicroscopy/applanation_tonometry.vue";
import GlassPresciptionList from "@/components/glasses_prescription/list/index.vue";
import PrescriptionList from "@/components/prescription/list/index.vue";
import ContactLensTestList from "@/components/contact_lens_test/list/index.vue";
import Allergy from "@/components/medical_record/hpp/allergy.vue";
import MedicationHistory from "@/components/medical_record/hpp/medication_history.vue";

import DynamicFormCore from "@/components/dynamic_form/core.vue";

export default {
  name: "Sumary",
  props: {
    attendance: Object,
  },
  components: {
    DiagnosticHypothesis,
    BreathTonometry,
    ApplanationTonometry,
    GlassPresciptionList,
    PrescriptionList,
    ContactLensTestList,
    Allergy,
    MedicationHistory,
    DynamicFormCore,
  },
  apollo: {
    historyPresentIllness: {
      query: require("@/graphql/history_present_illness.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    biomicroscopy: {
      query: require("@/graphql/biomicroscopy/biomicroscopy.gql"),
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    fundoscopy: {
      query: require("@/graphql/fundoscopy/fundoscopy.gql"),
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    conduct: {
      query: require("@/graphql/conduct/conduct.gql"),
      fetchPolicy: "no-cache",
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    diagnosticHypotheses: {
      query: require("@/graphql/diagnostic_hypotheses.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    familyHistory: {
      query: require("@/graphql/family_history.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    historyPathology: {
      query: require("@/graphql/history_pathology.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
    applanationTonometries: {
      query: require("@/graphql/biomicroscopy/applanation_tonometry/applanation_tonometries.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },

    breathTonometries: {
      query: require("@/graphql/biomicroscopy/breath_tonometry/breath_tonometries.gql"),
      variables() {
        return {
          attendanceId: this.attendance.id,
        };
      },
    },
   },
  computed: {
    activeDiagnosticHypotheses() {
      return this.lodash.filter(this.diagnosticHypotheses, {
        currentStatus: "active",
      });
    },
    inactiveDiagnosticHypotheses() {
      return this.lodash.filter(this.diagnosticHypotheses, {
        currentStatus: "inactive",
      });
    },
    hasHistoryPathology() {
      return this.historyPathology?.description;
    },
    hasHistoryPresentIllness() {
      return this.historyPresentIllness?.description;
    },
    hasConduct() {
      return this.conduct?.observation;
    },
    hasBio() {
      return this.biomicroscopy?.description;
    },

    hasFundoscopy() {
      return this.fundoscopy?.description;
    },

    hasApplanationTonometries() {
      return !this.lodash.isEmpty(this.applanationTonometries);
    },

    hasBreathTonometries() {
      return this.breathTonometries;
    },
  },
};
</script>

<style lang="scss" scoped></style>
